import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { translation } from '../../../../utils/helpers'

// Styles
import './inspectionitem.scss'

// Elements
import { ElementIcons } from '../../../../shared/elements/icons'
import Panel from '../../../../shared/elements/panel'
import Icon from '../../../../shared/elements/icon'
import Actions from '../../../../shared/elements/actions'

class InspectionItem extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount () {
  }
  componentWillUnmount () {
  }
  renderTitle (title) {
    // Image
    let image = 'Red_marking'
    if (this.props.checked) image = 'Green_chekmark'
    // On Click
    const onChangeMarking = () => {
      this.props.onHeaderClick()
    }
    let iconClass = 'icon'
    if (title.className) iconClass = title.className
    // Return
    let titleClass = 'title'
    if (this.props.showCheckmark) titleClass += ' clicker'
    return <div className={titleClass} onClick={onChangeMarking}>
      <img className={iconClass} src={title.icon} />
      <div>{translation(title.text)}</div>
      {this.props.showCheckmark && <img className='checkmark' src={'/images/icons/' + image + '.png'} />}
    </div>
  }

  render () {
    let text = translation(this.props.title.text)
    if (this.props.noTranslation) { text = this.props.title.text }
    return (
      <Panel title={text}>
        {this.props.showCheckmark && (
          <Actions>
            <Icon
              icon={this.props.checked ? ElementIcons.Inspection_Check : ElementIcons.Inspection_Cancel}
              onClick={this.props.onHeaderClick}
            />
          </Actions>
        )}

        {this.props.renderContent()}
      </Panel>
    )
  }
}
InspectionItem.defaultProps = {
  title: { icon: '/images/svgs/Cirkle_info-black.svg', text: 'placeholder' },
  showCheckmark: true,
  onHeaderClick: () => { },
  renderContent: () => {
    return <div> content placeholder</div>
  }
}
InspectionItem.propTypes = {
  showCheckmark: PropTypes.bool,
  checked: PropTypes.bool,
  title: PropTypes.object.isRequired,
  renderContent: PropTypes.func.isRequired,
  onHeaderClick: PropTypes.func.isRequired
}
InspectionItem.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired,
  // enum: React.PropTypes.func.isRequired
}
function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
})(InspectionItem)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderInspection/InspectionItem/index.js